import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { Label, Menu } from 'semantic-ui-react';
import AlphaProvider, { AlphaContext } from '../../cnr/contexts/AlphaContext';
import { DataContext } from '../../cnr/contexts/DataContext';
import { FilterContext } from '../../cnr/contexts/FilterContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { UiItemContext } from '../../cnr/contexts/UiItemContext';
import { getTabView, setHorizontalScroll } from '../../cnr/reducers/reducerHelpers/swipeHelpers';
import { uniqueKey } from '../../common/keys';
import { gEnums } from '../../enums/globalEnums';
import { currentHelpers } from '../../redirection/current';

const AlphabetMenu = (props) => {

  const grouping_default = {
    alphaDisplayType: gEnums.alphaDisplayTypes.verticalFull,
    useVerticalHidden: true,
    verticalOpacity: gEnums.opacityTypes.darkest,
    restrictToExisting: true,
  }

  const { isSolo, grouping: grouping_props, groupIndicator } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states

  // papsContext  
  const { view, viewKey } = paps_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { viewItem, _groupingOpts } = item_state ?? {}
  const { grouping: grouping_vi } = viewItem ?? {}

  // filterContext 
  const filterContext = useContext(FilterContext);
  const { uiFilter_handlers } = filterContext ?? {}

  // alphaContext
  const alphaContext = useContext(AlphaContext);
  const { alpha_state, alpha_handlers } = alphaContext ?? {}
  const { grouping: grouping_alpha, useAlpha, alphaItem, alphaItems, gutterItems, currentAlphaIndex, isVert, letterShowing, letterCount, snc, handleAlphaChange, groupedInfo } = alpha_state ?? {}

  let _grouping = grouping_default

  if (grouping_vi) { _grouping = grouping_vi }
  if (_groupingOpts) { _grouping = _groupingOpts }
  if (grouping_props) { _grouping = grouping_props }
  if (grouping_alpha) { _grouping = grouping_alpha }

  if (grouping_alpha) {
    grouping_alpha.showAlphaCount = true
  }

  const {
    fetchByAlphabet,
    restrictToExisting,
    showAlphaCount,
    showAlphaHeader,
    showFavorites,
    useHorizontalScroll,
  } = grouping_alpha ?? {}

  const _restrictToExisting = restrictToExisting || (props && props.restrictToExisting)

  // dataContext
  const dataContext = useContext(DataContext);
  const { data_state, data_handlers } = dataContext ?? {}
  const { viewListData } = data_state ?? {}

  let storageItem = 'alpha-item-'
  storageItem += viewKey ? view + '-' + viewKey : view

  const _menuContainerId = 'alpha-menu'

  const _currentLetter = currentAlphaIndex ? String.fromCharCode(currentAlphaIndex) : 65

  const scrollableDivRef = useRef(null);

  // const pointer = usePointer({
  //   enabled: isVert,
  //   active: letterShowing,
  //   getValueFromElement: (el) =>
  //     el.getAttribute('itemval') && parseInt(el.getAttribute('itemval'), 10),
  //   onChange: (value) =>
  //     alpha_handlers.handleSet_currentAlphaIndex(value),
  //   onCommit: () => handleSetAlphaItem(val),
  // });


  useEffect(() => {
    const htm = (e) => {
      // Check if the touch event target is within the scrollable div 
      if (e.target.closest('.menu-alphabet') && e.target.closest('.menu-alphabet').id === 'alpha-menu') {
        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', htm, { passive: false });

    return () => {
      document.removeEventListener('touchmove', htm);
    };
  }, [scrollableDivRef]);


  useEffect(() => {
    if (viewListData) {
      // viewListData, dataItems, restrictToExisting, storageItem, alphaValue, groupIndicator
      alpha_handlers.handleInit_alpha(viewListData, null, _restrictToExisting, storageItem, props.alphaValue, groupIndicator)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [viewListData]);

  useEffect(() => {
    // grouping, dataCount 
    // if (!grouping_alpha) {
    alpha_handlers.handleInit_grouping(_grouping, _.size(viewListData))
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [viewListData]);

  const hac = useCallback((ai) => {
    const _handleAlphaChange = handleAlphaChange || props.handleAlphaChange
    if (ai && _handleAlphaChange) {
      _handleAlphaChange(ai)
    }
  }, [handleAlphaChange, props.handleAlphaChange]);

  useEffect(() => {
    if (alphaItem) {
      if (fetchByAlphabet && data_handlers) {
        data_handlers.handleSetAlphabetValue(alphaItem)
      } else if (handleAlphaChange) {
        switch (alphaItem) {
          case 'sel':
            props.handleGotoTop()
            break;
          case 'nonsel':
            props.handleGotoBottom()
            break;
          default:
            hac(alphaItem)
        }
      } else {
        !isSolo && uiFilter_handlers && uiFilter_handlers.handleChange_alphaFilter(alphaItem, true)
        hac(alphaItem)
      }
      if (useHorizontalScroll) {
        const tvw = getTabView(_menuContainerId, 'am')
        tvw.setTab(alphaItems.length)
        const alphaIndex = alphaItems.indexOf(parseInt(alphaItem));
        setHorizontalScroll(tvw, _menuContainerId, alphaIndex)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [alphaItem]);

  const handleItemClick = (e, { name }) => {
    currentHelpers.storageItem_set(storageItem, name)
    alpha_handlers.handleSet_alphaItem(name)
  }

  const handleUpdateCurrentAlpha = (e, alphaIndex) => {
    if (alphaIndex !== currentAlphaIndex) {
      alpha_handlers.handleSet_currentAlphaIndex(alphaIndex);
      isSolo && props && props.handleMouseMove && props.handleMouseMove(e, alphaIndex)
    }
  }

  const handleTouchMove = (event) => {
    if (!event?.touches) { return; }
    const touchedItem = document.elementFromPoint(
      event?.touches[0]?.clientX,
      event?.touches[0]?.clientY
    );
    if (touchedItem && touchedItem.attributes && touchedItem.attributes['itemval'] && touchedItem.attributes['itemval'].value) {
      const itemValue = parseInt(touchedItem.attributes['itemval'].value)
      if (itemValue !== currentAlphaIndex) {
        alpha_handlers.handleSet_currentAlphaIndex(itemValue)
      }
    }
  }

  const handleSetAlphaItem = () => {
    alpha_handlers.handleSet_alphaItem(currentAlphaIndex)
    alpha_handlers.handleSet_letterShowing(false)
    currentHelpers.storageItem_set(storageItem, currentAlphaIndex)
  }

  const handleShowLetter = (e) => {
    if (e) { handleTouchMove(e) }
    alpha_handlers.handleSet_letterShowing(true)
  }

  const handleKillLetter = () => alpha_handlers.handleSet_letterShowing()

  const menuItem = (val, isChar, index, isGutter) => {
    let cn = null
    if (isVert && letterShowing && _currentLetter) {
      const _sel = isGutter ? _currentLetter === val : _currentLetter === String.fromCharCode(val)
      if (_sel) { cn = 'sel' }
    }

    // pointer.setVal(val)

    return <Menu.Item
      className={cn}
      id={'am_' + index}
      itemval={val}
      touchtype={'mi'}
      name={val.toString()}
      key={uniqueKey('abm', val)}
      active={val === parseInt(alphaItem)}
      onClick={handleItemClick}

      // onMouseMove={(e) => { isVert && letterShowing && handleUpdateCurrentAlpha(e, val) }}
      // onMouseUp={(e) => { isVert && handleSetAlphaItem(val) }}

      // onTouchStart={(e) => { isVert && letterShowing && handleUpdateCurrentAlpha(e, val) }}
      // onTouchMove={(e) => { isVert && handleTouchMove(e) }}
      // onTouchEnd={() => { isVert && handleSetAlphaItem(val) }}

      onPointerDown={(e) => {
        if (!isVert || !letterShowing) return;
        handleUpdateCurrentAlpha(e, val);
      }}

      onPointerMove={(e) => {
        if (!isVert || !letterShowing || e.buttons !== 1) return;
        handleUpdateCurrentAlpha(e, val);
      }}

      onPointerUp={() => {
        if (!isVert) return;
        handleSetAlphaItem(val);
      }}

    >
      {!isChar && String.fromCharCode(val)}
      {isChar && val}
    </Menu.Item>
  }

  const alphaMis = () => {
    const mis = alphaItems.map((ai, index) => {
      return menuItem(ai, null, index)
    })
    if (showFavorites) {
      mis.unshift(menuItem('Favs', true, alphaItems.length))
    }
    if (props.handleGotoTop) {
      mis.unshift(menuItem('sel', true, 0))
    }
    if (props.handleGotoBottom) {
      mis.push(menuItem('nonsel', true, 0))
    }
    return mis
  }

  const gutterMis = () => _.map(gutterItems, (gutterItem, index) => (menuItem(gutterItem, true, index, true)))

  let cn = snc ? 'alpha-index alpha-menu ' + snc.className : 'alpha-index alpha-menu'

  if (cn) {
    cn += letterShowing ? ' ' : ' dead'
  }

  const menu = () => <Menu
    ref={scrollableDivRef}
    id={_menuContainerId}
    // onMouseDown={(e) => { isVert && handleShowLetter(e) }}
    // onMouseLeave={(e) => { isVert && handleKillLetter(e) }}
    // onTouchStart={(e) => { isVert && handleShowLetter(e) }}
    // onTouchMove={(e) => { isVert && handleTouchMove(e) }}
    onPointerDown={(e) => {
      if (!isVert) return;
      handleShowLetter(e);
    }}

    onPointerMove={(e) => {
      if (!isVert) return;
      handleTouchMove(e); // reuse your existing logic, but update it for pointer events
    }}

    onPointerLeave={(e) => {
      if (!isVert) return;
      handleKillLetter(e);
    }}
    inverted
    borderless
    vertical={isVert ? true : false}
    compact={isVert ? true : null}
    className={cn}
    style={snc.style}
  >
    {alphaItems && !gutterItems && alphaMis()}
    {gutterItems && gutterMis()}
  </Menu >

  return useAlpha ? <React.Fragment>
    {isVert && letterShowing && <div className="circle-container" style={snc.style}>
      <div className="scrolling-letter">{_currentLetter}</div>
      {showAlphaCount && <div className="scrolling-count">{letterCount && letterCount[currentAlphaIndex] ? letterCount[currentAlphaIndex] : 0}</div>}
    </div>}
    {isVert && showAlphaHeader && <div className="show-letter" style={snc.style}>
      <Label circular color='blue'>{_currentLetter}</Label>
    </div>}
    {menu()}
  </React.Fragment> : <div></div>

}

const AlphabetMenuWithProvider = (props) => {
  return <AlphaProvider  {...props}>
    <AlphabetMenu />
  </AlphaProvider>
}

export default AlphabetMenuWithProvider